export var PartnerMatchCategory;
(function (PartnerMatchCategory) {
    PartnerMatchCategory["NEW"] = "NEW";
    PartnerMatchCategory["PRIORITY"] = "PRIORITY";
    PartnerMatchCategory["SECOND_MATCH"] = "SECOND_MATCH";
    PartnerMatchCategory["THIRD_MATCH"] = "THIRD_MATCH";
    PartnerMatchCategory["LAST_RESORT"] = "LAST_RESORT";
})(PartnerMatchCategory || (PartnerMatchCategory = {}));
